import pickBy from 'lodash/pickBy';
import { MAX_EVENT_VALUE_LENGTH } from '../components/internal/constants';
/**
 * This function aims to help keep the small fields of an object so that
 * the fields whose values are functions or large objects or larget strings
 * will be gone. The purpose is to keep those small fields so that we can put
 * the remaining fields into the omp event body.
 */

export var extractEventingFriendlyFields = function extractEventingFriendlyFields(obj) {
  return pickBy(obj, function (val) {
    return val === null || typeof val === 'boolean' || typeof val === 'number' || typeof val === 'string' && val.length <= MAX_EVENT_VALUE_LENGTH;
  });
};
export function useDebounce(func, delay) {
  var timeout;
  return function debounced() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var later = function later() {
      clearTimeout(timeout);
      func.apply(void 0, args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, delay);
  };
}
export function useThrottle(func, delay) {
  var time = Date.now();
  return function () {
    if (time + delay - Date.now() < 0) {
      func();
      time = Date.now();
    }
  };
}